import axios from "axios";
import { APIURL2 } from "@/main";
import { IGiftCardDTO } from "@shared/types";

export async function fetchGiftCard(code: string): Promise<IGiftCardDTO> {
  const normalizedCode = code.trim().toUpperCase();
  const { data } = await axios.get<IGiftCardDTO>(`${APIURL2}GiftCards/${normalizedCode}`);
  return data;
}
